/**
 * Company: SPHMedia
 * Description: [Top story for GE]
 */

import ArticleCard from "@components/Blocks/Card/Article/ArticleCard";
import { ProcessedArticleData } from "@transformer/useOSResponse";
import { ReactElement } from "react";

type GETopStoryWidgetProps = {
  articles: ProcessedArticleData[];
};

/**
 * TopStoryWidget
 * Description: [Editorial curated GE top stories]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function GETopStoryWidget(
  props: GETopStoryWidgetProps,
): ReactElement {
  const { articles } = props;

  const firstArticle = articles.slice(0, 1)[0];
  const otherArticles = articles.slice(1, 3);

  return (
    <div className="flex gap-5 flex-col">
      <div>
        <ArticleCard
          {...firstArticle}
          orientation="horizontal"
          variant="featured"
          displayWidth={414}
          displayHeight={310}
          forNewDesign={true}
        />
      </div>
      <div className="flex flex-col md:flex-row gap-5">
        {otherArticles.map((article, idx) => (
          <div key={`ge-top-story-${idx}`} className="md:w-1/2">
            <ArticleCard
              {...article}
              orientation="horizontal"
              variant="medium"
              displayWidth={113}
              displayHeight={86}
              forNewDesign={true}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
